export const GET_COLUMN_ALERT_CONFIG_LIST = 'GET_COLUMN_ALERT_CONFIG_LIST';
export const SET_COLUMN_ALERT_CONFIG_LIST = 'SET_COLUMN_ALERT_CONFIG_LIST';
export const DELETE_COLUMN_ALERT_CONFIG = 'DELETE_COLUMN_ALERT_CONFIG';
export const SAVE_COLUMN_ALERT_CONFIG = 'SAVE_COLUMN_ALERT_CONFIG';
